/* eslint-disable react/no-unstable-nested-components */
import { Tabs } from "@jhool-io/fe-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import React from "react";

import MyTasksList from "./MyTasksList/MyTasksList";
import AllTasksList from "./AllTasksList/AllTasksList";
import { useFetchUsersList } from "../../../hooks/queries/user-management";

export type ModalContent = "add-task" | "reassign-task";

export default function TasksListsWrapper() {
    const location = useLocation();
    const navigate = useNavigate();

    // Component states
    const [searchParams, setSearchParams] = useSearchParams();

    const tabInUrl = searchParams.get("tab");

    useFetchUsersList({ search_string: "" });

    const handleSetTabInUrl = (tab: string) => {
        searchParams.set("tab", tab);
        setSearchParams(searchParams);

        // reset local filters before switching
        navigate(
            searchParams.get("tab")
                ? `${location.pathname}?tab=${searchParams.get("tab")}`
                : location.pathname
        );
    };

    const tabItems = [
        {
            key: "my_tasks",
            label: "My tasks",
            children: <MyTasksList />,
            onClick: () =>
                handleSetTabInUrl(
                    "my_tasks&status[]=not_started&status[]=in_progress&category[]=user_created_todo"
                ),
        },
        {
            key: "all_tasks",
            label: "All tasks",
            children: <AllTasksList />,
            onClick: () =>
                handleSetTabInUrl(
                    "all_tasks&status[]=not_started&status[]=in_progress&category[]=user_created_todo"
                ),
        },
    ];

    return (
        <>
            {/* <Dialog open={Boolean(taskIdInUrl) && !modalInView}>
                <DialogContent
                    title="Task Details"
                    handleCloseDialog={handleCloseDetailsDialog}
                    submitBtnFormValue="edit-task"
                    isSubmitBtnDisabled={isUpdateTaskMutating > 0}
                    isCancelBtnDisabled={isUpdateTaskMutating > 0}
                >
                    <TaskDetails
                        setHideModal={() => handleSetModalInView(null)}
                    />
                </DialogContent>
            </Dialog> */}

            <Tabs
                defaultActiveKey={tabInUrl || "my_tasks"}
                size="medium"
                className="w-full rounded-b-none"
                items={tabItems}
            />
        </>
    );
}
